import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";


export async function getAll(): Promise<any[]> {
  return (await axiosInstance.get("/Areas/GetAreaList")).data;
}
export async function deleteRegion(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Areas/Delete", null, { headers, params })).data;
}

